module.exports = __webpack_public_path__ + "img/seq5.f51f0602.png";